import { useTranslation } from 'react-i18next';

import BaseTag from './BaseTag';

import type { FC } from 'react';

interface Props {
  small?: boolean;
}

const SalesForceIntegrationTag: FC<Props> = ({ small }) => {
  const { t } = useTranslation();

  return (
    <BaseTag
      text={t('labels.salesForce')}
      color="orange"
      dataCy="salesForce-tag"
      small={small}
    />
  );
};

export default SalesForceIntegrationTag;
